import axios from 'axios';

async function getPrenhas(filters: ApiFiltersType, token?: string | null) {
  try {
    const response = await axios({
      headers: {
        Authorization: token
      },
      method: 'get',
      url: `${process.env.REACT_APP_SERVICE_API}/rest/json/animais/prenhas`,
      params: {
        ...filters,
      }
    });
    return response.data
  } catch (error) {
    console.error(error);
  }
}

export { getPrenhas };
